export default "__VITE_ASSET__Bo0DW_mT__"